import axiosClient from "../api/axiosClient";

/** Fetch the promoter's watermark settings. Returns array (0 or 1 item). */
export const getWatermark = () =>
  axiosClient.get("/Image/user");

/**
 * Upload a watermark image via BulkCompressed.
 * @param {File} file
 * @param {number} [countryCode=49]
 */
export const uploadWatermarkImage = (file, countryCode = 49) => {
  const formData = new FormData();
  formData.append("files", file);
  formData.append("folderName", "Watermark_Images");
  formData.append("countryCode", String(countryCode));
  // eventId intentionally omitted (null)
  return axiosClient.post("/Image/BulkCompressed", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/**
 * Create a new watermark setting.
 * @param {{ WatermarkImageUrl: string, Position: string, Opacity: number, SizePercent: number }} data
 */
export const createWatermark = (data) =>
  axiosClient.post("/Image/CreateWM", data);

/**
 * Update an existing watermark setting.
 * @param {string} id
 * @param {{ WatermarkImageUrl: string, Position: string, Opacity: number, SizePercent: number }} data
 */
export const updateWatermark = (id, data) =>
  axiosClient.put(`/Image/UpdateVM/${id}`, data);

/** Delete the watermark setting. */
export const deleteWatermark = (id) =>
  axiosClient.delete(`/Image/DeleteVM/${id}`);

